"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const useAppUid_1 = require("../../../webapp/behaviours/useAppUid");
const WebsiteDetailWrapper = styled_components_1.default.div `
  height: 92vh;
  overflow: hidden;
  position: relative;
  width: 100%;
`;
const ButtonWrapper = styled_components_1.default.div `
  width: 50%;
  margin: 24px auto;
`;
const withHttp = (url) => (!/^https?:\/\//i.test(url) ? `http://${url}` : url);
const Websitedetail = (props) => {
    const transformBookingUrl = (0, useAppUid_1.useAppUid)();
    const openWebsite = () => {
        const processedUrl = transformBookingUrl(withHttp(props.websiteData.url));
        window.open(processedUrl, "_blank");
    };
    return (react_1.default.createElement(WebsiteDetailWrapper, { className: "website-page" },
        react_1.default.createElement(ButtonWrapper, null,
            react_1.default.createElement(material_1.Button, { variant: "contained", fullWidth: true, size: "large", onClick: openWebsite }, i18n_js_1.default.t("open_external_website")))));
};
exports.default = Websitedetail;
